import { useEffect } from "react";
import Greetings from "./Greetings";
import OnBoarding from "./OnBoarding";
import Resources from "./Resources";
import { useContainer } from "context/Containers";
import { useSites } from "api/sites";

export default function Dashboard() {
  const { leftSideContainer, rightSideContainer } = useContainer();
  const { isLoading } = useSites();
  useEffect(() => {
    if (leftSideContainer.current && leftSideContainer.current.clientHeight) {
      rightSideContainer.current.style.height =
        leftSideContainer.current.clientHeight - 60 + "px";
    }
  }, [leftSideContainer, rightSideContainer, isLoading]);

  return (
    <>
      <div
        className="flex flex-col gap-15"
        style={{
          overflowY: "auto",
        }}
        ref={rightSideContainer}
      >
        <Greetings />
        <OnBoarding />
        <Resources />
      </div>
    </>
  );
}
